import { render } from "./CustomizableTable.vue?vue&type=template&id=1626c979&scoped=true"
import script from "./CustomizableTable.vue?vue&type=script&lang=js"
export * from "./CustomizableTable.vue?vue&type=script&lang=js"

import "./CustomizableTable.vue?vue&type=style&index=0&id=1626c979&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1626c979"]])

export default __exports__